module.exports = __webpack_public_path__ + "static/media/1615172358318.1be099b3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/1615172358318.jpg
// module id = 339
// module chunks = 2